export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
};
